import { ModuleWithProviders, NgModule } from '@angular/core';

import { CustomRouterOutletDirective } from './custom-router-outlet.directive';
import { defaultScrollPositionRestorationConfig } from './default-scroll-position-restoration-config';
import { ScrollPositionRestorationConfig } from './scroll-position-restoration-config';
import { SCROLL_POSITION_RESTORATION_CONFIG_INJECTION_TOKEN } from './scroll-position-restoration-config-injection-token';
import { ScrollPositionRestorationService } from './scroll-position-restoration.service';

/**
 * Код модуля скопирован из библиотеки https://github.com/TheJLifeX/ngx-scroll-position-restoration
 * т.к. сама библиотека не работает с Angular выше 14 версии
 */
@NgModule({
  declarations: [CustomRouterOutletDirective],
  exports: [CustomRouterOutletDirective],
  providers: [ScrollPositionRestorationService],
})
export class ScrollPositionRestorationModule {
  /**
   * Since ScrollPositionRestorationModule can be imported in child modules, it is needed to track if the scrollPositionRestorationService has been already initialized to avoid duplicate calls of the `initialize` method.
   */
  private static serviceInitialized = false;

  constructor(scrollPositionRestorationService: ScrollPositionRestorationService) {
    if (!ScrollPositionRestorationModule.serviceInitialized) {
      scrollPositionRestorationService.initialize();
      ScrollPositionRestorationModule.serviceInitialized = true;
    }
  }

  static forRoot(config?: ScrollPositionRestorationConfig): ModuleWithProviders<ScrollPositionRestorationModule> {
    return {
      ngModule: ScrollPositionRestorationModule,
      providers: [
        {
          provide: SCROLL_POSITION_RESTORATION_CONFIG_INJECTION_TOKEN,
          useValue: Object.assign(defaultScrollPositionRestorationConfig, config),
        },
      ],
    };
  }
}
